
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-on-course-layout',
  imports: [RouterOutlet, RouterModule],
  templateUrl: './on-course-layout.component.html',
  styleUrl: './on-course-layout.component.scss'
})
export class OnCourseLayoutComponent {

}
